import React from 'react';
import Link from '@sats-group/fresh-fitness-ui-lib/react/link';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import Layout from 'root/client/components/layout/layout';

import type { EmployeeLogInPage as Props } from './employee-log-in-page.types';

const EmployeeLogInPage: React.FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ layout, link, title }) => (
  <Layout {...layout}>
    <div className="employee-log-in-page">
      <div className="employee-log-in-page__title">
        <Text
          elementName="h1"
          size={Text.sizes.header2}
          variant={Text.variants.hero}
        >
          {title}
        </Text>
      </div>
      <Link {...link} />
    </div>
  </Layout>
);

export default EmployeeLogInPage;
